import React from 'react';
const FloatButtonGroupContext = /*#__PURE__*/React.createContext(undefined);
export const {
  Provider: FloatButtonGroupProvider
} = FloatButtonGroupContext;
export default FloatButtonGroupContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/float-button/context.js
// module id = 663
// module chunks = 0